/* eslint-disable no-bitwise */
import { findBestMatch } from 'string-similarity';

export const convertToFloatFormat = (value) => {
  let parsedValue = '0';
  if (value) {
    if (value.indexOf(',') > value.indexOf('.')) {
      parsedValue = value.replace(/\./g, '').replace(/,/, '.');
    } else {
      return value;
    }
  }
  return parsedValue;
};

export const generateInvKey = () => {
  const timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
  return (
    timestamp +
    'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => ((Math.random() * 16) | 0).toString(16)).toLowerCase()
  );
};

export const formatDate = (date) => {
  if (!date || date === ' ') {
    return ' ';
  }
  const [day, month, year] = date.split('.');
  return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`;
};

export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const generateQueryParams = (params) => {
  let queryParamString = '';
  Object.keys(params).forEach((key) => {
    if (params[key]) {
      queryParamString += `${key}=${params[key]}&`;
    }
  });
  return queryParamString;
};

export const findBestStringMatch = (vatId, textBlocks) => {
  if (vatId && textBlocks.length) {
    const matches = findBestMatch(vatId, textBlocks);
    return matches.bestMatchIndex;
  }
  return 0;
};
